import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementFrLocale from 'element-ui/lib/locale/lang/fr'

import momentCN from 'moment/locale/zh-cn'
import enLocale from './en'
import zhLocale from './zh'
import frLocale from './fr'

import { getI18nMessage } from '@/api'
import { normalizeLanguageCode, syncRequestContextCookies } from '@/utils/context-cookie'

const elementLocales = {
  en: elementEnLocale,
  zh: elementZhLocale,
  fr: elementFrLocale
}

const localMessages = {
  en: enLocale,
  zh: { ...zhLocale, ...momentCN },
  fr: frLocale
}

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...momentCN,
    ...zhLocale,
    ...elementZhLocale
  },
  fr: {
    ...frLocale,
    ...elementFrLocale
  }
}

export function getLanguage() {
  // 优先读取 language cookie
  const chooseLanguage = normalizeLanguageCode(Cookies.get('language'))
  if (chooseLanguage) return chooseLanguage

  // 如果没有，尝试读取 lang cookie（兼容旧数据）
  const chooseLang = normalizeLanguageCode(Cookies.get('lang'))
  if (chooseLang) return chooseLang

  const language = normalizeLanguageCode(navigator.language || navigator.browserLanguage)
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}

async function loadRemoteMessages(lang) {
  try {
    const { data } = await getI18nMessage(lang)
    console.log(`[i18n] Loaded remote messages for ${lang}:`, data)

    console.log(data)
    console.log(data)
    // 确保 remoteMessages 是一个对象
    let remoteMessages = {}
    if (data && data.languageResources) {
      remoteMessages = data.languageResources
      remoteMessages = {
        ...remoteMessages
      }
      console.log(remoteMessages)
    } else if (data && typeof resp === 'object') {
      // 如果返回的直接就是消息对象
      remoteMessages = data
    }

    const mergedMessages = {
      // ...localMessages[lang], // 保留本地翻译
      ...elementLocales[lang], // Element UI 的翻译
      ...remoteMessages // 接口返回的翻译
    }

    console.log(`[i18n] Merged messages for ${lang}:`, mergedMessages)
    return mergedMessages
  } catch (e) {
    // 返回本地翻译作为降级方案
    return {
      ...localMessages[lang],
      ...elementLocales[lang]
    }
  }
}

let i18n = null

// 提供获取已初始化 i18n 实例的方法
export function getI18nInstance() {
  return i18n
}

export async function initI18n() {
  const currentLang = getLanguage()
  syncRequestContextCookies(currentLang)

  const messages = await loadRemoteMessages(currentLang)
  i18n = new VueI18n({
    locale: currentLang,
    messages: {
      [currentLang]: messages
    },
    silentTranslationWarn: true
  })

  return i18n
}

export async function changeLanguage(lang) {
  const normalizedLanguage = normalizeLanguageCode(lang) || 'en'
  Cookies.set('language', normalizedLanguage)
  syncRequestContextCookies(normalizedLanguage)

  // 重新加载远程消息
  const newMessages = await loadRemoteMessages(normalizedLanguage)

  // 更新 i18n 实例 - 先设置消息，再切换语言
  if (i18n) {
    // 先设置新语言的消息
    i18n.setLocaleMessage(normalizedLanguage, newMessages)

    // 等待 Vue 响应式系统更新后再切换语言
    await Vue.nextTick()

    // 再切换当前语言
    // eslint-disable-next-line require-atomic-updates
    i18n.locale = normalizedLanguage

    // 再次等待确保更新完成
    await Vue.nextTick()

    console.log(`[i18n] Language changed to ${normalizedLanguage}, current locale:`, i18n.locale)
  }

  return i18n
}

export default i18n
